import { render } from "./SalesReport.vue?vue&type=template&id=41a935e6&scoped=true&ts=true"
import script from "./SalesReport.vue?vue&type=script&lang=ts"
export * from "./SalesReport.vue?vue&type=script&lang=ts"

import "./SalesReport.vue?vue&type=style&index=0&id=41a935e6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41a935e6"]])

export default __exports__